<footer class="section footer-creative context-dark">
    <div class="footer-creative-aside adminfooter">
        <div class="container ">
            <p class="rights ">
                <span>Designed & Developed by</span>&nbsp;<a class="myAnchor" href="http://www.knowledge.gr/ksa/shared/index.jsp?context=101 " target="_blank">Knowledge Broadband Services</a><span class="copyright-year"></span>
                <!-- <a routerLink="/privacy">Privacy Policy</a> -->
            </p>
        </div>
    </div>
</footer>